require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-ivano-gianola.json") })
        }
      }, "path---interviste-ivano-gianola");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-ivano-gianola!./.cache/json/interviste-ivano-gianola.json
// module id = 674
// module chunks = 231608221292675